<script setup lang="ts">
import Grid from "@/shared/components/ui/helper/Grid.vue";
import {useI18n} from 'vue-i18n'
import {AddressInput, Country} from "@/shared/graphql/types";
import {FormInput} from "@/shared/components/ui/form2/element";
import FormCountrySelect from "@/shared/components/ui/form2/element/FormCountrySelect.vue";
import {computed} from "vue";
import {useTenantStore} from "@/shared/stores/tenant.store.ts";

const {t} = useI18n()
const tenantStore = useTenantStore()

interface Props {
  showName?: boolean
  isHouseNumberSeparate?: boolean
  required?: boolean
  countries?: Country[]
}

const modelValue = defineModel<AddressInput>()

const props = withDefaults(defineProps<Props>(), {
  showName: false,
  isHouseNumberSeparate: true,
})
const myCountries = computed(() => props.countries ?? (tenantStore.tenant?.tenantSettings?.countries ?? []))
const label = props.isHouseNumberSeparate ? t('shared.address.address') : t('shared.address.address_one_line')
const placeholderAddress = props.isHouseNumberSeparate ? t('shared.address.address') : t('shared.address.address_one_line')
</script>
<!--DO NOT REMOVE THE ROOT DIV, it is necessary for the v-validation path component to work correctly, it places a data attribute on the root so children know there parent path -->
<template>
  <div class="flex flex-col gap-y-default">
    <Grid :columns="6" :override="true" class="">
      <FormCountrySelect
          v-model="modelValue.country"
          v-validation
          :countries="myCountries"
          :label="t('shared.address.country')"
          class="col-span-6"
          :required="required"
      />

      <FormInput
          v-model="modelValue.street"
          v-validation
          :class="isHouseNumberSeparate ? 'col-span-4' : 'col-span-6'"
          :label="label"
          :placeholder="placeholderAddress"
          :required="required"
          id="delivery-address"
      />
      <FormInput v-if="isHouseNumberSeparate"
                 v-model="modelValue.houseNumber"
                 v-validation
                 :label="t('shared.common.number')"
                 :placeholder="t('shared.address.number_short')"
                 :required="required"
                 id="house-number"
      />
      <FormInput v-if="isHouseNumberSeparate"
                 v-model="modelValue.busNumber"
                 v-validation
                 :label="t('shared.address.postal_box')"
                 :placeholder="t('shared.address.postal_box')"
      />

      <FormInput
          v-model="modelValue.extra"
          v-validation
          class="col-span-6"
          :placeholder="t('shared.address.address2')"
          :required="required"
          id="delivery-address"
      />
    </Grid>

    <Grid :columns="3" :override="true">
      <FormInput
          v-model="modelValue.zipCode"
          v-validation
          :label="t('shared.address.zip_code')"
          :placeholder="t('shared.address.zip_code')"
          :required="required"
          id="zip-code"
      />

      <FormInput
          v-model="modelValue.city"
          v-validation
          :label="t('shared.address.city')"
          :placeholder="t('shared.address.city')"
          :required="required"
          id="city"
          class="col-span-2"
      />

    </Grid>
  </div>
</template>